<div class="content layout horizontal center top" style="width: 100%;">
     <div [ngStyle]="{'width': isLesserThanXs?'96%':'800px'}" style="margin-top: 20px;">
          <div class="borderedtitlebox layout horizontal center middle">
               <div [ngClass]="{'smalltitle': isLesserThanXs, 'title': !isLesserThanXs}">ELEZIONI 2021</div>
          </div>
          <h1>{{'MENU.CONTACTS'|translate}}</h1>
          <div [innerHtml]="'CONTACTS'|translate"></div>
     </div>
</div>
<app-public-area-footer></app-public-area-footer>
